import styled from 'styled-components'
import { ButtonEdit } from 'Components/Buttons/ButtonEdit'

export const ButtonEditInsideSection = styled(ButtonEdit)`
  position: absolute !important;
  right: 40px;
  top: 40px;
  width: 44px;
  height: 44px;
  background-color: ${props => props.theme.colors.primary};

  svg {
    width: 20px;
    height: 20px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }
`
